export default __webpack_public_path__ + "static/media/11-JioSavaan.21b45830.png";